import { Button, Typography } from 'antd';
import { Link } from 'react-router-dom';
import './css/Preview.css';
const { Title } = Typography;

const Preview = () => {
    document.title = "Code.ak";
    return (
        <div className="welcome-container">
            <div className="welcome-header">
                <div className="logo">
                    <img src="/icon1.png" alt="Code.ak logo" className="logo-icon" />
                    <span className="logo-text">Code.ak</span>
                </div>
                <div className="auth-buttons">
                    <Link to="/login"><Button type="text">Log in</Button></Link>
                    <Link to="/register"><Button type="primary" shape="round">Sign up</Button></Link>
                </div>
            </div>
            <div className="welcome-overlay">
                <div className="welcome-content left-align">
                    <Title level={1} className="welcome-title">
                        Code yourself<br/>with
                    </Title>
                    <Link to="/login">
                        <div className="composite-button">
                            <span className="text-part">Code.ak</span>
                            <button className="icon-button">
                                →
                            </button>
                        </div>
                    </Link>

                </div>
            </div>
        </div>
    );
};

export default Preview;
